const isOutOfStock = ({ unlimited, quantity }) => !unlimited && quantity === 0;

export default isOutOfStock;
